// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3taOi","type":"styles_type__3_Nd1","choices":"styles_choices__3yaK7"};